import { Reveal } from "../Motion";

// Clean, simple page header — solid dark, no photo overlay.
// One tidy section: eyebrow + heading + optional subtitle + optional actions.
export default function PageHeader({ eyebrow, title, subtitle, children, center = false }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10 bg-[#0a0a0a]">
      {/* subtle depth (no photo) */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-60"
        style={{ background: "radial-gradient(60% 120% at 50% -20%, rgba(255,209,0,0.10), transparent 60%)" }}
      />
      <div className={`relative z-10 max-w-7xl mx-auto px-5 md:px-10 pt-28 md:pt-32 pb-14 md:pb-16 ${center ? "text-center" : ""}`}>
        <Reveal>
          {eyebrow && (
            <p className="text-[#ffd100] font-semibold uppercase tracking-[0.2em] text-sm mb-3">{eyebrow}</p>
          )}
          <h1 className="font-display font-bold text-white text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[0.98]">
            {title}
          </h1>
          {subtitle && (
            <p className={`mt-5 text-neutral-300 text-lg md:text-xl leading-relaxed max-w-2xl ${center ? "mx-auto" : ""}`}>
              {subtitle}
            </p>
          )}
          {children && <div className={`mt-8 flex flex-col sm:flex-row gap-4 ${center ? "justify-center" : ""}`}>{children}</div>}
        </Reveal>
      </div>
    </section>
  );
}
